/**
 * Live capability state, shared between the composition root and the
 * settings screen.
 *
 * A REAL BUG THIS FIXES. Before this file existed, `index.ts` held its own
 * module-scoped `capability` variable gating `hardware.isConfigured()` (the
 * drawer) and `ticketHardware.isConfigured()` (tickets) — refreshed only at
 * `onEnable()` (till load). `PeripheralSettings.tsx` called
 * `detectCapability()` directly into its OWN local React state to paint the
 * status line, never touching the module's copy. Pairing a printer mid-
 * session made the settings screen say "Connected" while the actual sale-
 * and refund-triggered paths kept reading a stale pre-pairing capability —
 * silently gated closed, because "no printer configured" is a designed-
 * silent case (FR-216), not an error. "Test the drawer" masked this: it
 * calls `activeTransport.kick()` directly, bypassing `isConfigured()`
 * entirely, so the manual test could pass while a real cash sale or a real
 * ticket enqueue both silently did nothing.
 *
 * ONE SOURCE OF TRUTH FIXES IT: both the settings screen and the trigger
 * paths now read and refresh through this same module-level state, so
 * pairing a device here is pairing it everywhere.
 *
 * A SEPARATE FILE FROM `index.ts` for the same reason `ticket-settings.ts`
 * is: `PeripheralSettings.tsx` needs to read and refresh this state, and
 * `index.ts` already imports `PeripheralSettings.tsx` for the `till.settings`
 * slot — importing back from `index.ts` would be circular.
 */

import { activeTransport } from "./select-transport";
import { detectCapability, UNSUPPORTED, type DrawerCapability } from "./capability";
import { DrawerStatusMonitor } from "./drawer-status";

export const drawerStatus = new DrawerStatusMonitor(activeTransport);

let capability: DrawerCapability = UNSUPPORTED;

/** The last probe. Read-only to callers; refreshed by `refreshCapability`. */
export function currentCapability(): DrawerCapability {
  return capability;
}

/**
 * Re-probe and update the ONE state every gate reads. Call this whenever the
 * capability might have changed — till load, a fresh pairing, a manual
 * "Check again" — never keep a second copy anywhere else.
 */
export async function refreshCapability(): Promise<DrawerCapability> {
  capability = await detectCapability(activeTransport);
  drawerStatus.start(capability);
  return capability;
}

export function resetCapability(): void {
  capability = UNSUPPORTED;
  drawerStatus.stop();
}
